import { render, staticRenderFns } from "./c-links-list.vue?vue&type=template&id=7ca10152&scoped=true&"
import script from "./c-links-list.vue?vue&type=script&lang=js&"
export * from "./c-links-list.vue?vue&type=script&lang=js&"
import style0 from "./c-links-list.vue?vue&type=style&index=0&id=7ca10152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca10152",
  null
  
)

export default component.exports